/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlBatchRequest {
    getFixupPrototypeFunction() { return ControlBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<ControlBatchRequest>): ControlBatchRequest {
        let obj = Object.assign(new ControlBatchRequest(), model);
        ControlBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlBatchRequest>): ControlBatchRequest {
        if (!model) return null;
        return ControlBatchRequest.newInstance(<ControlBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlBatchRequest) {
        if (!obj) return;

        models.ControlBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlBatchRequest): boolean {
        Object.setPrototypeOf(obj, ControlBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of compliance control IDs
     */
    compliance_control_ids: Array<string>;

    /**
     * List of compliance control URIs
     */
    compliance_control_uris: Array<string>;

}
